import React from 'react';
import PillBtn from './PillBtn';

// Extracted from LessonWorkspace.js (Phase 3 of the platform-health plan:
// split the file mechanically, without changing behavior). Student-side
// view-only mirror of the teacher's live-session pill.
export default function StudentStatusPill({
  isStudent,
  otherParticipants,
  isLiveSession,
  isStudentLocked,
  studentCanJoinCall,
  videoOpen,
  onJoinCall,
}) {
  const show = isStudent && (otherParticipants.length > 0 || isLiveSession || isStudentLocked || (studentCanJoinCall && !videoOpen));
  if (!show) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 16,
      right: 16,
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      background: 'rgba(255,255,255,0.92)',
      backdropFilter: 'blur(12px)',
      WebkitBackdropFilter: 'blur(12px)',
      borderRadius: 999,
      boxShadow: '0 2px 12px rgba(0,0,0,0.12)',
      border: '1px solid rgba(0,0,0,0.07)',
      padding: '0 4px',
      height: 36,
      gap: 0,
    }}>
      {/* Teacher online dot + name */}
      {otherParticipants.length > 0 && (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 5,
          padding: '0 10px 0 8px',
          fontSize: 12, fontWeight: 500, color: '#16a34a',
          maxWidth: 120, overflow: 'hidden', whiteSpace: 'nowrap',
        }}>
          <span style={{ flexShrink: 0, width: 7, height: 7, borderRadius: '50%', background: '#22c55e', boxShadow: '0 0 5px rgba(34,197,94,0.7)' }} />
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {otherParticipants[0].name || 'Teacher'}
          </span>
        </div>
      )}

      {/* Separator before status label */}
      {otherParticipants.length > 0 && (isLiveSession || isStudentLocked) && (
        <span style={{ width: 1, height: 18, background: 'rgba(0,0,0,0.1)', flexShrink: 0 }} />
      )}

      {/* Live / Watching label */}
      {isStudentLocked ? (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 5,
          padding: '0 10px',
          fontSize: 12, fontWeight: 600, color: '#ee5a24',
          whiteSpace: 'nowrap',
        }}>
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/>
          </svg>
          Watching
        </div>
      ) : isLiveSession ? (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 5,
          padding: '0 10px',
          fontSize: 12, fontWeight: 600, color: '#16a34a',
          whiteSpace: 'nowrap',
        }}>
          <span style={{ width: 6, height: 6, borderRadius: '50%', background: '#22c55e', flexShrink: 0 }} />
          Live
        </div>
      ) : null}

      {/* Join call button */}
      {studentCanJoinCall && !videoOpen && (<>
        <span style={{ width: 1, height: 18, background: 'rgba(0,0,0,0.08)', flexShrink: 0 }} />
        <PillBtn
          onClick={onJoinCall}
          title="Join call"
          color="#3b82f6"
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="currentColor">
            <path d="M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1-9.4 0-17-7.6-17-17 0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.3 0 .7-.2 1z"/>
          </svg>
        </PillBtn>
      </>)}
    </div>
  );
}
